<template>
  <div
    class="referral-rewards-message-box-bg flex-center"
    v-if="showMessageBox"
  >
    <div class="referral-rewards-message-box">
      <div class="referral-rewards-message-box-gradient-top"></div>
      <div class="referral-rewards-message-box-gradient-bottom"></div>
      <div class="referral-rewards-message-box-gradient-img" v-if="!isfrom">
        <i class="icon icon-rewards-bg-img"></i>
      </div>
      <div class="referral-rewards-message-box-top">
        <i class="icon icon-close" @click="onShowMessageBox"></i>
      </div>
      <div class="referral-rewards-message-box-main">
        <div class="referral-rewards-message-box-content">
          <template v-if="!isfrom">
            <h3>Get your referral link below</h3>
            <p>Input your email address:</p>
            <div
              class="referral-rewards-input margin-bottom-40 email-input flex-align-center"
            >
              <div class="input-icon emil flex-center">
                <i class="icon icon-rewards-emil"></i>
              </div>
              <input type="text" v-model="from.email" />

              <span v-if="fromEmailsState === 'error'" class="text-error"
                >* Please enter a valid email</span
              >
            </div>

            <p>Your f(x)Core 0x wallet address:</p>
            <div
              class="referral-rewards-input margin-bottom-40 address-input flex-align-center"
            >
              <div class="input-icon addr flex-center">
                <i class="icon icon-rewards-addr"></i>
              </div>
              <input type="text" disabled :value="getUser.address" />
            </div>
            <div class="box-but" @click="toShareNow">
              <ButtonCommon
                type="marginXBridge"
                width="100%"
                :disabled="isShareDisabled"
              >
                <strong class="text-download">Submit</strong>
              </ButtonCommon>
            </div>
          </template>
          <template v-else>
            <div class="referral-link-box">
              <h3>Your Referral Link</h3>
              <p class="text-opacity link-text">
                Please copy and share your personalised referral link as shown
                below.
              </p>
              <div class="referral-rewards-link-box">
                <h6>{{ inviteUrl }}</h6>
              </div>
              <div
                class="box-but"
                v-clipboard:copy="inviteUrl"
                v-clipboard:success="onCopy"
              >
                <ButtonCommon type="marginXBridge" width="100%">
                  <strong class="text-download">Copy Link</strong>
                </ButtonCommon>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonCommon from "@/components/Common/button";
import { mapGetters } from "vuex";
import md5 from "js-md5";
import api from "@/service/api";

export default {
  name: "referralRewardsMessageBox",
  data() {
    return {
      isFromEmail: false,
      fromEmailsState: "",
      from: {
        ownerAddress: "",
        email: "",
      },
    };
  },
  components: {
    ButtonCommon,
  },
  props: {
    referralRewardsInviteCode: {
      type: String,
      default: "",
    },
    showMessageBox: {
      type: Boolean,
      default: false,
    },
    isfrom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    isShareDisabled() {
      return this.from.email === "";
    },

    inviteUrl() {
      const MARGINX = process.env.VUE_APP_OPTIONS;

      return `${MARGINX}/?InviteCode=${this.referralRewardsInviteCode}`;
    },
  },
  methods: {
    onShowMessageBox() {
      this.$emit("update:showMessageBox", !this.showMessageBox);
      this.$emit("update:isfrom", false);
    },
    onCopy(e) {
      this.$notify({
        title: "Copied",
        message: `You just copied: ${e.text}`,
        type: "success",
        showClose: true,
        duration: 5000,
      });
    },

    setFromEmailsState() {
      this.fromEmailsState = this.isFromEmail
        ? "efficient"
        : this.from.email === ""
        ? ""
        : "error";
    },
    emailBlurHandler() {
      this.isFromEmail = false;

      const reg =
        /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;

      if (!reg.test(this.from.email)) {
        this.setFromEmailsState();
        return;
      }

      this.isFromEmail = true;
      this.setFromEmailsState();
    },
    async toShareNow() {
      if (this.$st.isClick()) return;
      this.emailBlurHandler();

      if (this.isFromEmail) {
        this.from.ownerAddress = this.getUser.address;
        try {
          this.isAnimation = true;
          const timestamp = Math.floor(new Date().getTime() / 1000);
          const signData = `J5XwZrT4hpwMvg+${this.from.ownerAddress}+${this.from.email}+${timestamp}`;
          const sign = md5(signData);
          const opt = {
            ...this.from,
            timestamp,
          };

          const res = await api["createInviteUserCode"](opt, {
            headers: {
              sign,
            },
          });

          this.$emit("update:referralRewardsInviteCode", res.inviteCode);

          // this.inviteUrl = `${MARGINX}?InviteCode=${
          //   this.inviteCode !== "" ? this.inviteCode : res.inviteCode
          // }`;

          this.$emit("update:isfrom", true);

          console.log(
            "shareNow-data",
            res.inviteCode,
            res.repeatCreateInviteCodeFlag,
            res.airDrop
          );

          this.isAnimation = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.margin-bottom-40 {
  margin-bottom: 40px;
}
.referral-rewards-message-box-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.68);
  flex-direction: column;
  .referral-rewards-message-box-main {
    position: relative;
    border-radius: 20px;
  }
  .referral-rewards-message-box-bott {
    padding: 24px 40px;
    box-sizing: border-box;
    border-radius: 20px;

    .text-min {
      text-align: center;
      width: 320px;
      line-height: 20px;
      margin: 0 auto;
    }
  }
  .referral-rewards-message-box {
    position: relative;
    width: 800px;
    background: #101314;
    border-radius: 12px;
    overflow: hidden;

    .referral-rewards-message-box-gradient-top {
      position: absolute;
      left: 0;
      top: 0;
      width: 200px;
      height: 200px;
      background-image: linear-gradient(90deg, #18eed8 10%, #a6f616 100%);
      border-radius: 200px;
      filter: blur(80px);
      z-index: 0;
    }
    .referral-rewards-message-box-gradient-bottom {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 200px;
      height: 200px;
      background-image: linear-gradient(90deg, #18eed8 10%, #a6f616 100%);
      border-radius: 200px;
      filter: blur(200px);
      z-index: 0;
    }

    .referral-rewards-message-box-gradient-img {
      position: absolute;
      right: -20px;
      bottom: 0;
      width: 345px;
      height: 345px;
      z-index: 1;
    }

    .referral-rewards-message-box-top {
      position: absolute;
      top: 24px;
      right: 24px;
      z-index: 10;
      .icon-close {
        cursor: pointer;
      }
    }
    .but-refresh {
      opacity: 0.5;
      margin-top: 16px;
      cursor: pointer;
      &:hover {
        opacity: 1;
        strong {
          text-decoration: underline;
        }
      }
    }
    .box-but {
      width: 320px;
    }
    .referral-rewards-message-box-content {
      padding: 60px;

      .referral-rewards-link-box {
        padding: 30px 36px;
        background: #2a2c32;
        border-radius: 4px;
        margin-bottom: 60px;
      }

      h3 {
        margin-bottom: 40px;
      }
      p {
        margin-bottom: 20px;
      }

      .link-text {
        margin-bottom: 60px;
      }

      .referral-link-box {
        position: relative;
        text-align: center;
        .box-but {
          margin: 0 auto;
        }
      }
      .referral-rewards-input {
        position: relative;
        border-radius: 4px;
        width: 400px;
        height: 40px;

        .text-error {
          z-index: 1;
          position: absolute;
          left: 0;
          bottom: -20px;
          color: #ef1842;
          padding: 4px 0 0;
        }

        &.email-input {
          background: rgba(16, 19, 20, 0.8);
          border: 0.5px solid rgba(166, 246, 22, 1);
        }

        &.address-input {
          background: #2a2c32;
          border: 0px;
        }

        .input-icon {
          width: 40px;
          height: 40px;

          &.emil {
            background: #a6f616;
            border-radius: 4px 0px 0px 4px;
          }

          &.addr {
            background: #3a3c44;
            border-radius: 4px 0px 0px 4px;
          }
        }

        input {
          outline: none;
          background: none;
          border: none;
          width: 100%;
          font-size: 14px;
          color: #fff;
          line-height: 40px;
          padding: 0 16px;

          &::placeholder {
            color: #191919;
            opacity: 0.75;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
